'use client';
import React from 'react';

import { Subscribable, SubscribableEvent } from '@benzinga/subscribable';
import Hooks from '@benzinga/hooks';
import { WorkspaceContext } from './workspace-context';

export const useActiveWorkspaceSubscriber = <
  T extends Subscribable<Event, SubscriberArgs>,
  Event extends SubscribableEvent<string> = T extends Subscribable<infer E1> ? E1 : never,
  SubscriberArgs = unknown,
>(
  subscribable: T | undefined,
  callback: (event: Event) => void,
  args?: SubscriberArgs,
  types?: Event['type'][],
  disableTimeout = false,
): T | undefined => {
  const { isActiveWorkspace } = React.useContext(WorkspaceContext);
  const feed = isActiveWorkspace ? subscribable : undefined;
  Hooks.useSubscriber(feed, callback, args, types, disableTimeout);
  return feed;
};
